export enum SpendType {
  EXPENSE = 'expense',
  INCOME = 'income',
  SAVING = 'saving',
}
